import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { AuthServiceService } from '../http/auth-service.service'
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(public auth: AuthServiceService, public router: Router,) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.loggedIn) {
      this.auth.isloggedIn().pipe(map(res => {
        if (res.message = "Session Expired"){
          this.router.navigate(['login'])
          this.auth.setLogedout(false)
          return false
        }else {
          return true
        }
      }))
      return true;
    } else {
      this.router.navigate(['login'])
      return false
    }
    
  }
  
}
